import React from 'react';
import editorStyles from '../QuestionEditor/QuestionEditor.module.css';
import {useIntl} from "react-intl";
import styles from "../QuestionEditor/QuestionEditor.module.css";
import Textarea from "../../common/Textarea/Textarea";

const ParagraphSpecificEditor = () => {
    const intl = useIntl(); // <--- Получаем intl
    return (
        <div>
            <Textarea
                readOnly
                disabled
                placeholder={intl.formatMessage({ id: "question.detailed_answer" })}
                rows="2"
            />
        </div>
    );
};
export default ParagraphSpecificEditor;
